import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
// import { handelRightClick } from "./AppUtility";
import "./App.css";
import Blogs from "./Components/Blogs/Blogs";
import Home from "./Components/Home/Home";
import Navbar from "./Components/Navbar/Navbar";
import AOS from "aos";
import "aos/dist/aos.css";

function App() {
  // useEffect(() => {
  //   AOS.init();
  // }, []);

  // document.addEventListener("contextmenu", handelRightClick);
  return (
    <>
      <Navbar>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
        </Routes>
      </Navbar>
    </>
  );
}

export default App;
